import Cookies from 'js-cookie';

export default function cookies() {
    const cookies = document.getElementById('cookies');
    if (!cookies) {
        return;
    }
    const accept = document.getElementById('accept');
    if (!accept) {
        return;
    }
    if (Cookies.get('gdpr_dismiss')) {
        cookies.classList.add('none');
    } else {
        cookies.classList.remove('none');
        accept.addEventListener('click', function (ev) {
            cookies.classList.add('none');
            Cookies.set('gdpr_dismiss', '1', { expires: 365, path: '' });
        });
    }
}
